import React from "react";
import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-quill/dist/quill.snow.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "react-dropzone-uploader/dist/styles.css";
import "animate.css";
import "react-phone-number-input/style.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import "moment/locale/fr";
import { fr } from "yup-locales";
import { setLocale } from "yup";
import "react-phone-input-2/lib/style.css";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "react-datepicker/dist/react-datepicker.css";
import Geocode from "react-geocode";
import "react-alice-carousel/lib/alice-carousel.css";
import { GoogleApikey } from "./utils/http";

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey(GoogleApikey);

// set response language. Defaults to english.
Geocode.setLanguage("fr");

// set response region. Its optional.
// A Geocoding request with region=es (Spain) will return the Spanish city.
Geocode.setRegion("sn");
setLocale(fr);
let persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
